/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { TruexAdRendererCTV, TruexAdRendererMobile, TruexAdRendererDesktop } from "@truex/ad-renderer";
import Loading from "../common/Loading";

const TrueXAdComponent = ({ onAdCompleted, contentData, selectChoiceCard }) => {
    const adRef = useRef(null);
    const tarInstance = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const vastConfigUrl = process.env.REACT_APP_TEMP_AD_URL;

        const detectDeviceType = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
                return "mobile";
            } else if (/smarttv|hbbtv|appletv|roku|firetv|tizen|webos|tv/.test(userAgent)) {
                return "ctv";
            }
            return "desktop";
        };

        const initAdRenderer = async () => {
            try {
                // console.log("🚀 Fetching TrueX VAST Config URL:", vastConfigUrl);
                const response = await fetch(vastConfigUrl);
                if (!response.ok) {
                    // console.error("❌ Failed to fetch VAST config:", response.statusText);
                    resumePlayback();
                    setIsLoading(false);
                    return;
                }
                const adParametersFromVastAsString = await response.text();

                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(adParametersFromVastAsString, "application/xml");
                if (xmlDoc.querySelector("parsererror")) {
                    // console.error("❌ Error parsing XML:", xmlDoc.querySelector("parsererror").textContent);
                    resumePlayback();
                    setIsLoading(false);
                    return;
                }
                const adParametersNode = xmlDoc.querySelector("AdParameters");
                if (!adParametersNode) {
                    // console.error("❌ No AdParameters found in VAST XML.");
                    resumePlayback();
                    setIsLoading(false);
                    return;
                }
                const adParametersJson = JSON.parse(adParametersNode.textContent);
                // console.log("📦 Extracted AdParameters:", adParametersJson);

                // ✅ Initialize TrueX AdRenderer
                const deviceType = detectDeviceType();
                // console.log("📱 Detected Device Type:", deviceType);

                if (deviceType === "mobile") {
                    tarInstance.current = new TruexAdRendererMobile(adParametersJson);
                } else if (deviceType === "desktop") {
                    tarInstance.current = new TruexAdRendererDesktop(adParametersJson);
                } else if (deviceType === "ctv") {
                    tarInstance.current = new TruexAdRendererCTV(adParametersJson);
                } else {
                    // console.error("❌ Unsupported device type:", deviceType);
                    resumePlayback();
                    setIsLoading(false);
                    return;
                }
                tarInstance.current.subscribe(handleAdEvent);

                const customDiv = document.querySelector('.custom_div_showing_ad');
                
                const vastConfig = await tarInstance.current.init();
                await tarInstance.current.start(vastConfig, customDiv);
                setIsLoading(false);
            } catch (error) {
                // console.error("❌ Error initializing TrueX AdRenderer:", error);
                resumePlayback();
                setIsLoading(false);
            }
        };

        initAdRenderer();

        return () => {
            if (tarInstance.current) {
                tarInstance.current.stop();
                tarInstance.current.unsubscribe(handleAdEvent);
                tarInstance.current = null;
            }
        };
    }, []);

    const handleAdEvent = (event) => {
        // console.log("Ad Event:", event);
        if (!tarInstance.current) return;
        switch (event.type) {
            case "adStarted":
                // console.info('Ad Started successfully.');
                break;
            case "adDisplayed":
                // console.info('Ad Displayed successfully.');
                break;
            case "adError":
                // console.error('❌ Ad error:', event.errorMessage);
                resumePlayback();
                break;
            case "noAdsAvailable":
                console.warn("⚠️ No ads available.");
                resumePlayback();
                break;
            case "adCompleted":
                console.log("✅ Ad completed!");
                resumePlayback();
                break;
            case "optIn":
                console.log("ℹ️ User opted in of the ad.");
                selectChoiceCard(true);
                break;
            case "optOut":
                console.log("ℹ️ User opted out of the ad.");
                selectChoiceCard(false);
                break;
            case "adFreePod":
                // console.log("ℹ️ Interactive ad has been finished.");
                // resumePlayback();
                break;
            case "popupWebsite":
                // console.log("popupWebsite - User clicked external link", event.type, event);
                if (event?.url) {
                    // console.log("Navigating to:", event.url);
                    window.open(event.url, '_blank');
                } else {
                    // console.warn("popupWebsite event received but no URL provided");
                }
                break;
            default:
                // console.log("ℹ️ Unhandled Ad Event:", event.type, event);
                break;
        }
    };

    const resumePlayback = () => {
        if (onAdCompleted) {
            onAdCompleted();
        }
    };

    if (isLoading) {
        return <Loading showVideo={false} />;
    }

    return (
        <div ref={adRef} style={{ width: "100%", height: "auto", position: "relative" }}></div>
    );
};

export default TrueXAdComponent;